/* eslint-disable camelcase */
import React from 'react'
import { NavLink, useLocation, useHistory } from 'react-router-dom'
import logo from '../../../images/logo.png'
import { SIDE_MENU, ADMIN_SIDE_MENU } from './constants'
import { useSelector } from 'react-redux'
import { checkPrivilages } from '../../../utils/helpers'
import { dispatch } from '../../../redux/store'
import DropDownButton from '../adminSideNavDropDown/sideNavDropDown'
import { LANDING_PAGE_URL } from '../../../utils/constants'

const SideMenu = () => {
  const history = useHistory()
  const { permissions, userInfo } = useSelector(({ auth }) => auth.authUser)

  const handleLogout = async () => {
    await dispatch.auth.logout()
    history.push('/login')
  }

  const { pathname } = useLocation()

  return (
    <aside className='w-72 admin-side-menu shadow-2xl fixed inset-y-0 left-0 z-40 flex flex-col min-h-0'>
      <div className='px-3 border-b-2 border-gray-200 pb-3 flex-shrink-0'>
        <a href={LANDING_PAGE_URL}>
          <img src={logo} alt='logo' className='inline-block mt-5' />
        </a>
      </div>

      {/* Navigation */}
      <nav className='flex-1 py-4 overflow-y-scroll custom-scrollbar min-h-0'>
        <div className='px-2'>
          {userInfo?.is_admin === 0 &&
            SIDE_MENU.map(({ id, path, url, title, image }) => {
              const isActive = pathname === path || (Array.isArray(path) && path.includes(pathname))
              return (
                <NavLink
                  key={id}
                  to={url}
                  className={`
                    group relative flex items-center px-4 py-3 mx-2 mb-1 rounded-xl text-gray-700 
                    transition-all duration-300 ease-out hover:bg-gradient-to-r hover:from-blue-500 hover:to-blue-600 
                    hover:text-white hover:shadow-lg hover:scale-[1.02] hover:-translate-y-0.5
                    ${
                      isActive
                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg'
                        : ''
                    }
                    hover:before:absolute hover:before:inset-0 hover:before:rounded-xl hover:before:bg-gradient-to-r 
                    hover:before:from-blue-500 hover:before:to-blue-600 hover:before:opacity-0 hover:before:transition-opacity 
                    hover:before:duration-300 hover:hover:before:opacity-100
                  `}
                >
                  <div
                    className={`
                    absolute -left-2 top-0 bottom-0 w-1 rounded-r-full transition-all duration-300
                    ${
                      isActive
                        ? 'bg-white shadow-sm'
                        : 'bg-transparent group-hover:bg-white group-hover:shadow-sm'
                    }
                  `}
                  />
                  <img
                    src={image}
                    alt={title}
                    className={`
                      transition-all duration-300 mr-3 w-5 h-5 filter relative z-10
                      group-hover:scale-110 group-hover:rotate-3 group-hover:drop-shadow-sm
                      ${
                        isActive
                          ? 'brightness-0 invert scale-110'
                          : 'group-hover:brightness-0 group-hover:invert'
                      }
                    `}
                  />
                  <span
                    className={`
                      font-medium transition-all duration-300 relative z-10
                      group-hover:font-semibold group-hover:tracking-wide
                      ${isActive ? 'text-white' : 'group-hover:text-white'}
                    `}
                  >
                    {title}
                  </span>
                  {isActive && (
                    <div className='ml-auto w-2 h-2 bg-white rounded-full animate-pulse shadow-sm' />
                  )}
                  <div className='absolute inset-0 rounded-xl bg-gradient-to-r from-blue-500 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10' />
                </NavLink>
              )
            })}

          {userInfo?.is_admin === 1 &&
            ADMIN_SIDE_MENU.map(({ id, path, url, title, image, privileges, options, type }) => {
              const isAllowed = checkPrivilages(privileges, permissions)
              const isActive = pathname === path || (Array.isArray(path) && path.includes(pathname))

              return (
                isAllowed &&
                (type === 'dropdown' ? (
                  <DropDownButton
                    key={id}
                    title={title}
                    options={options}
                    image={image}
                    showTitle
                    isActive={isActive}
                  />
                ) : (
                  <NavLink
                    key={id}
                    to={url}
                    className={`
                      group relative flex items-center px-4 py-3 mx-2 mb-1 rounded-xl text-gray-700 
                      transition-all duration-300 ease-out hover:bg-gradient-to-r hover:from-blue-500 hover:to-blue-600 
                      hover:text-white hover:shadow-lg hover:scale-[1.02] hover:-translate-y-0.5
                      ${
                        isActive
                          ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg'
                          : ''
                      }
                    `}
                  >
                    <div
                      className={`
                      absolute -left-2 top-0 bottom-0 w-1 rounded-r-full transition-all duration-300
                      ${
                        isActive
                          ? 'bg-white shadow-sm'
                          : 'bg-transparent group-hover:bg-white group-hover:shadow-sm'
                      }
                    `}
                    />
                    <img
                      src={image}
                      alt={title}
                      className={`
                        transition-all duration-300 mr-3 w-5 h-5 filter relative z-10
                        group-hover:scale-110 group-hover:rotate-3 group-hover:drop-shadow-sm
                        ${
                          isActive
                            ? 'brightness-0 invert scale-110'
                            : 'group-hover:brightness-0 group-hover:invert'
                        }
                      `}
                    />
                    <span
                      className={`
                        font-medium transition-all duration-300 relative z-10
                        group-hover:font-semibold group-hover:tracking-wide
                        ${isActive ? 'text-white' : 'group-hover:text-white'}
                      `}
                    >
                      {title}
                    </span>
                    {isActive && (
                      <div className='ml-auto w-2 h-2 bg-white rounded-full animate-pulse shadow-sm' />
                    )}
                    <div className='absolute inset-0 rounded-xl bg-gradient-to-r from-blue-500 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10' />
                  </NavLink>
                ))
              )
            })}
        </div>
      </nav>

      {/* Logout Button */}
      <div className='px-4 py-4 border-t border-gray-100 flex-shrink-0'>
        <button
          onClick={handleLogout}
          className='
            group w-full flex items-center px-4 py-3 rounded-xl text-red-600
            hover:bg-red-50 hover:text-red-700 transition-all duration-200 ease-in-out
          '
        >
          <i className='fas fa-sign-out-alt mr-3 group-hover:scale-110 transition-transform duration-200' />
          <span className='font-medium'>Log Out</span>
        </button>
      </div>
    </aside>
  )
}

export default SideMenu
